export default __webpack_public_path__ + "static/media/NoSearchMessagesImage.b606b0c8.svg";